var scope_0 = require('/Users/thomassaw/Projects/Venturemore/app/www/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/299930ef285581a940194110eec8a749.js').default;export default
        Object.assign({}, scope_0 )
    